import React from "react";
import {
  HomePageProgressButton,
  HomePageProgressCard,
} from "./HomePageProgress";
import { OdysseyAttempt } from "@graphql";
import { graphql, useStaticQuery, withPrefix } from "gatsby";

type HomePageExamProgressProps = {
  attempt: Pick<OdysseyAttempt, "id" | "testId">;
};

export function HomePageExamProgress({ attempt }: HomePageExamProgressProps) {
  const { exams, certifications } =
    useStaticQuery<Queries.HomePageExamProgressQuery>(graphql`
      query HomePageExamProgress {
        exams: allExam {
          nodes {
            slug
            progressId
            certificationId
          }
        }
        certifications: allCertification {
          nodes {
            slug
            progressId
            title
          }
        }
      }
    `);

  const exam = exams.nodes.find((node) => node.progressId === attempt.testId);

  if (!exam) {
    throw new Error("Exam not found");
  }

  const certification = certifications.nodes.find(
    (node) => node.progressId === exam.certificationId
  );

  if (!certification) {
    throw new Error("Certification not found");
  }

  return (
    <HomePageProgressCard
      type="Certification"
      title={certification.title}
      subtitle="Exam in progress"
      thumb={{ src: withPrefix("/assets/default-exam-bg.svg") }}
    >
      <HomePageProgressButton to={`/exams/${exam.slug}/${attempt.id}`}>
        Resume progress
      </HomePageProgressButton>
    </HomePageProgressCard>
  );
}
